<script setup>

const props = defineProps({
	color: String,
})

</script>

<template >
	<svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
		<path
			d="M10.08 0.399941C9.55 0.929941 9.55 1.79994 10.08 2.32994L17.01 9.25994H1.36C0.61 9.25994 0 9.86994 0 10.6199V10.6399C0 11.3899 0.61 11.9999 1.36 11.9999H17L10.07 18.9299C9.54 19.4599 9.54 20.3299 10.07 20.8599C10.6 21.3899 11.47 21.3899 12 20.8599L22.23 10.6299L12.01 0.399941C11.48 -0.130059 10.61 -0.130059 10.08 0.399941Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
	</svg>
</template>